import React from 'react';
import './CentralQuarterIcon.css'
import {CENTRAL_QUARTER_PREFIX} from "../../../constants/tokens";
import FlagLayers from "../FlagIcon/FlagLayers";

const CentralQuarterIcon = ({token, className = ''}) => {
  const playerColor = token.replace(CENTRAL_QUARTER_PREFIX, '');

  return (
    <div className={`central-quarter-icon-container ${className}`}>
      <img
        className={`central-quarter_quarter-icon`}
        src={'/img/hexes/quarter_base.4ec61fc0.png'}
        alt={'central quarter ' + playerColor}
      />
      <FlagLayers color={playerColor}/>
    </div>
  );
};

export default CentralQuarterIcon;
